import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { Project, ProjectQueryParams } from '../models/project.model';

export abstract class ProjectGateway {
  abstract listProjects(params: ProjectQueryParams): Observable<ListResponse<Project>>;
}
